module.exports = __webpack_public_path__ + "static/media/30OIOS11.0ada3842.jpg";